// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { HistoryType } from '@shared/utils/History/HistoryType';
import { TerceraChartCashItemSeriesDataType } from '../Series/TerceraChartCashItemSeriesEnums';
import { PlateBase } from './PlateBase';
import { PriceFormatter } from '@shared/utils/Instruments/PriceFormatter';
import { StringUtils } from '@shared/utils/StringUtils';
export class PlateOverlay extends PlateBase {
    constructor(terceraChartOverlay) {
        super();
        this.terceraChartOverlay = terceraChartOverlay;
        this.isOverlay = true;
    }
    GetHover() {
        return this.terceraChartOverlay.Selected;
    }
    SetHover(value) {
        this.terceraChartOverlay.Selected = value;
    }
    GetSelected() {
        return this.terceraChartOverlay.chart.ActiveOverlayGet() === this.terceraChartOverlay;
    }
    SetSelected() {
        this.terceraChartOverlay.chart.FocusedOverlay = this.terceraChartOverlay;
        this.terceraChartOverlay.chart.ActiveOverlaySet(this.terceraChartOverlay);
    }
    GetVisible() {
        return this.terceraChartOverlay.mainPriceRenderer.Visible;
    }
    getTextName() {
        if (this.terceraChartOverlay.ActiveInstrument != null) {
            return (Resources.getResource('chart.menu.PlateOverlay.Overlay') +
                ': ' +
                this.terceraChartOverlay.ActiveInstrument.DisplayName());
        }
        return 'Empty symbol';
    }
    getTextValue(lastMouseHoverBarIndex, lineNumber, seriesSettings = null) {
        const overlayCashItemSeries = this.terceraChartOverlay.mainPriceRenderer.Series;
        if (isNullOrUndefined(overlayCashItemSeries)) {
            return '';
        }
        let value = 0;
        const overlayCashItem = overlayCashItemSeries.CashItem;
        if (lastMouseHoverBarIndex === this.nullBarIndex && !overlayCashItem.isRealTimeBuilding) {
            value = overlayCashItem.realTimeBar.Close;
        }
        else if (!overlayCashItem.FNonEmptyCashArray[lastMouseHoverBarIndex]) {
            return StringUtils.THREE_DASHES;
        }
        else {
            value = overlayCashItem.FNonEmptyCashArray[lastMouseHoverBarIndex].Close;
        }
        if (Math.abs(value) === Number.MAX_VALUE || isNaN(value)) {
            value = 0;
        }
        if (this.terceraChartOverlay.ActiveInstrument != null) {
            const dataType = seriesSettings != null ? seriesSettings.DataType : TerceraChartCashItemSeriesDataType.Absolute;
            switch (dataType) {
                case TerceraChartCashItemSeriesDataType.Relative:
                    return seriesSettings.relativeDataConverter.Calculate(value).toFixed(2) + '%';
            }
            return this.terceraChartOverlay.ActiveInstrument.formatPrice(value);
        }
        else {
            return PriceFormatter.formatPrice(value, 5);
        }
    }
    getBrush(lineNumber) {
        if (this.terceraChartOverlay.HistoryType === HistoryType.ASK) {
            return this.terceraChartOverlay.AskOverlayBrush;
        }
        else if (this.terceraChartOverlay.HistoryType === HistoryType.LAST) {
            return this.terceraChartOverlay.LastOverlayBrush;
        }
        else {
            return this.terceraChartOverlay.BidOverlayBrush;
        }
    }
    getLinesCount() {
        return 1; // close only
    }
    Dispose() {
        this.terceraChartOverlay = null;
    }
    getTypeName() {
        return this.getPropertiesText() + ' ' + this.getTextName();
    }
    getCloseTT() {
        return this.getCloseText() + ' ' + this.getTextName();
    }
    getVisibilityTT() {
        return 'Show/Hide overlay lines';
    }
    getPropertiesText() {
        return Resources.getResource('chart.menu.PlateOverlaySettings');
    }
    getCloseText() {
        return Resources.getResource('chart.menu.PlateOverlayRemove');
    }
    getVisibilityText() {
        return Resources.getResource('chart.menu.PlateOverlayVisible');
    }
    getMouseHoverBarIndex(lastMouseMovePt, window, cashItemSeries) {
        if (isNullOrUndefined(cashItemSeries)) {
            return this.nullBarIndex;
        }
        const overlayCashItem = cashItemSeries.CashItem;
        if (lastMouseMovePt.IsEmpty() && overlayCashItem.isRealTimeBuilding) {
            return overlayCashItem.FNonEmptyCashArray.length - 1; // last bar
        }
        return super.getMouseHoverBarIndex(lastMouseMovePt, window, cashItemSeries);
    }
}
